// extracted by mini-css-extract-plugin
export var banner = "_hv-0";
export var closeButton = "_hv-2";
export var greenCheckmark = "_hv-3";
export var hereLink = "_hv-4";
export var titleIcon = "_hv-1";